export const STORAGE_ACCESS_TOKEN = 'minhaagenda-spa-logintoken';
export const STORAGE_USER = 'minhaagenda-spa-userdetails';
export const STORAGE_COMPANY_SETTINGS = 'minhaagenda-spa-companysettings';
export const STORAGE_COMANDA_LIST_PERIOD_FILTER_TYPE =
  'minhaagenda-spa-STORAGE_COMANDA_LIST_PERIOD_FILTER_TYPE';
export const STORAGE_DASHBOARD_TIME_PERIOD_TYPE = 'minhaagenda-spa-STORAGE_DASHBOARD_TIME_PERIOD_TYPE';
export const STORAGE_LAST_SELECTED_COMANDA_TYPE = 'minhaagenda-spa-STORAGE_LAST_SELECTED_COMANDA_TYPE';
export const STORAGE_AGENDA_EMPLOYEE_SELECTION = 'minhaagenda-spa-STORAGE_AGENDA_EMPLOYEE_SELECTION';
export const STORAGE_AGENDA_ROOM_SELECTION = 'minhaagenda-spa-STORAGE_AGENDA_ROOM_SELECTION';
export const STORAGE_PERFORMANCE_COMPANY_TIME_PERIOD_TYPE =
  'minhaagenda-spa-STORAGE_PERFORMANCE_COMPANY_TIME_PERIOD_TYPE';
export const STORAGE_AGENDA_LAYOUT_CONFIG = 'minhaagenda-spa-STORAGE_AGENDA_LAYOUT_CONFIG';

export const CLIENT_SECRET =
  process.env.NODE_ENV === 'production'
    ? 'bWluaGFhZ2VuZGEtc3BhOjZMR2tQdVpTcDhWS3A5dQ=='
    : 'bWluaGFhZ2VuZGEtc3BhOjZMR2tQdVpTcDhWS3A5dQ==';

export const ROLE_ADMIN = 'ADMIN';
export const ROLE_SECRETARY = 'SECRETARY';
export const ROLE_SECRETARY_LIMITED = 'SECRETARY_LIMITED';

export const ROLE_EMPLOYEE = 'EMPLOYEE';
export const ROLE_EMPLOYEE_NOSERVICEVALUE = 'EMPLOYEE_NOSERVICEVALUE';
export const ROLE_EMPLOYEE_NOCUSTOMER = 'EMPLOYEE_NOCUSTOMER';
export const ROLE_EMPLOYEE_NOCUSTOMER_NOSERVICEVALUE = 'EMPLOYEE_NOCUSTOMER_NOSERVICEVALUE';

export const ROLE_EMPLOYEE_INDEPENDENT = 'EMPLOYEE_INDEPENDENT';
export const ROLE_EMPLOYEE_INDEPENDENT_NOCUSTOMER = 'EMPLOYEE_INDEPENDENT_NOCUSTOMER';
export const ROLE_EMPLOYEE_INDEPENDENT_NOSERVICEVALUE = 'EMPLOYEE_INDEPENDENT_NOSERVICEVALUE';
export const ROLE_EMPLOYEE_INDEPENDENT_NOCUSTOMER_NOSERVICEVALUE =
  'EMPLOYEE_INDEPENDENT_NOCUSTOMER_NOSERVICEVALUE';

export const ROLE_EMPLOYEE_SECRETARY = 'EMPLOYEE_SECRETARY';

export const ROLE_EMPLOYEE_MULTI = 'EMPLOYEE_MULTI';
export const ROLE_EMPLOYEE_MULTI_NEW = 'EMPLOYEE_MULTI_NEW';
export const ROLE_EMPLOYEE_MULTI_NEW_NOCUSTOMER = 'EMPLOYEE_MULTI_NEW_NOCUSTOMER';
export const ROLE_EMPLOYEE_MULTI_NEW_NOSERVICEVALUE = 'EMPLOYEE_MULTI_NEW_NOSERVICEVALUE';
export const ROLE_EMPLOYEE_MULTI_NEW_NOCUSTOMER_NOSERVICEVALUE =
  'EMPLOYEE_MULTI_NEW_NOCUSTOMER_NOSERVICEVALUE';

export const ROLE_MENU_CUSTOMERS = 'MENU_CUSTOMERS';
export const ROLE_MENU_SERVICES = 'MENU_SERVICES';
export const ROLE_MENU_PRODUCTS = 'MENU_PRODUCTS';
export const ROLE_MENU_EXPENSES = 'MENU_EXPENSES';
export const ROLE_VIEW_COMMISSIONS = 'VIEW_COMMISSIONS';
export const ROLE_VIEW_COMMISSION_PAYMENTS = 'VIEW_COMMISSION_PAYMENTS';
export const ROLE_CANNOT_EDIT_APPOINTMENTS = 'CANNOT_EDIT_APPOINTMENTS';
export const ROLE_CANNOT_DELETE_APPOINTMENTS = 'CANNOT_DELETE_APPOINTMENTS';
export const ROLE_CAN_EDIT_PRICE_ON_APPOINTMENT_CREATION = 'CAN_EDIT_PRICE_ON_APPOINTMENT_CREATION';
export const ROLE_CANNOT_CREATE_SERVICE_ON_APPOINTMENT = 'CANNOT_CREATE_SERVICE_ON_APPOINTMENT';
export const ROLE_VIEW_COMMISSIONS_GROSS_TOTAL = 'VIEW_COMMISSIONS_GROSS_TOTAL';

export const ALL_ROLES_SECRETARY = [ROLE_SECRETARY, ROLE_SECRETARY_LIMITED];

export const ROLES_ADMIN = [ROLE_ADMIN];

export const ROLES_ALL_SECRETARY_AND_ADMIN = [ROLE_ADMIN, ...ALL_ROLES_SECRETARY];

export const ROLES_NOCUSTOMER = [
  ROLE_EMPLOYEE_NOCUSTOMER,
  ROLE_EMPLOYEE_NOCUSTOMER_NOSERVICEVALUE,
  ROLE_EMPLOYEE_INDEPENDENT_NOCUSTOMER,
  ROLE_EMPLOYEE_INDEPENDENT_NOCUSTOMER_NOSERVICEVALUE,
  ROLE_EMPLOYEE_MULTI_NEW_NOCUSTOMER,
  ROLE_EMPLOYEE_MULTI_NEW_NOCUSTOMER_NOSERVICEVALUE,
];

export const ROLES_NOSERVICEVALUE = [
  ROLE_EMPLOYEE_NOSERVICEVALUE,
  ROLE_EMPLOYEE_NOCUSTOMER_NOSERVICEVALUE,
  ROLE_EMPLOYEE_INDEPENDENT_NOSERVICEVALUE,
  ROLE_EMPLOYEE_INDEPENDENT_NOCUSTOMER_NOSERVICEVALUE,
  ROLE_EMPLOYEE_MULTI_NEW_NOSERVICEVALUE,
  ROLE_EMPLOYEE_MULTI_NEW_NOCUSTOMER_NOSERVICEVALUE,
];

export const ROLES_MANAGEMENT_ALL = [
  ROLE_ADMIN,
  ROLE_SECRETARY,
  ROLE_EMPLOYEE_SECRETARY,
  ROLE_EMPLOYEE_MULTI,
];
export const ROLES_MANAGEMENT_BASIC = [...ROLES_MANAGEMENT_ALL, ROLE_SECRETARY_LIMITED];

export const ROLES_ALLOW_AGENDA_FROM_OTHERS = [
  ROLE_ADMIN,
  ROLE_SECRETARY,
  ROLE_SECRETARY_LIMITED,
  ROLE_EMPLOYEE_SECRETARY,
  ROLE_EMPLOYEE_MULTI,
  ROLE_EMPLOYEE_MULTI_NEW,
  ROLE_EMPLOYEE_MULTI_NEW_NOCUSTOMER,
  ROLE_EMPLOYEE_MULTI_NEW_NOSERVICEVALUE,
  ROLE_EMPLOYEE_MULTI_NEW_NOCUSTOMER_NOSERVICEVALUE,
];

export const ROLES_ALLOW_AGENDA_FROM_OTHERS_AND_MENU_CUSTOMERS = [
  ...ROLES_ALLOW_AGENDA_FROM_OTHERS,
  ROLE_MENU_CUSTOMERS,
];

export const ROLES_ALLOW_AGENDA = [
  ...ROLES_ALLOW_AGENDA_FROM_OTHERS,
  ROLE_EMPLOYEE_INDEPENDENT,
  ROLE_EMPLOYEE_INDEPENDENT_NOCUSTOMER,
  ROLE_EMPLOYEE_INDEPENDENT_NOSERVICEVALUE,
  ROLE_EMPLOYEE_INDEPENDENT_NOCUSTOMER_NOSERVICEVALUE,
];

export const MINHAAGENDA_PHONE = '5534999003306';
// export const MINHAAGENDA_PHONE = '+5534988449998';

export const BR_TIMEZONES = [
  'America/Sao_Paulo',
  'America/Rio_Branco',
  'America/Fortaleza',
  'America/Manaus',
  'America/Maceio',
  'America/Campo_Grande',
  'America/Cuiaba',
  'America/Noronha',
  'America/Bahia',
  'America/Belem',
  'America/Boa_Vista',
  'America/Fortaleza',
  'America/Porto_Velho',
  'America/Recife',
  'America/Araguaina',
];

export const STRIPE_CLIENT_KEY =
  process.env.NODE_ENV === 'production'
    ? 'pk_live_51HpH9wCH2VDTM9e6ZhRFbyP7w3JB4hvh0Lv25PsiUrsvrB2J7vEU4wNmh8zQ7oobXtKIaajK1l4Zl2UtNzG74iYS004IRiclSf'
    : 'pk_test_51HpH9wCH2VDTM9e6PlIgAendIsCt6PymiD2ZiH73YQL787NIBy4zriiExhyBIMKuQIosQ8bUOzbC8Lcl7CfXIwrf00SklHucTX';
